module.exports = __webpack_public_path__ + "img/bss2008.66cd1090.png";